<template>
  <div class="guarantor-new wrapper">
    <div class="steps">
      <Steps :current="currentStep" direction="vertical">
        <Step title="选择地区" content="选择项目所在地区"></Step>
        <Step title="选择行业" content="选择行业主管部门"></Step>
        <Step title="项目信息" content="选择或填写项目信息"></Step>
        <Step title="保函信息" content="填写保函信息"></Step>
        <Step title="提交" content="签名并提交"></Step>
      </Steps>
    </div>
    <div class="views">
      <router-view
        :data="guaranteeModel"
        :projectRegisterEnabled="projectRegisterEnabled"
        @go-backward="goBackward"
        @finish-step1="finishStep1"
        @finish-step2="finishStep2"
        @finish-step3="finishStep3"
        @finish-step4="finishStep4"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'guarantor-new',
  props: {
  },
  data () {
    return {
      projectRegisterEnabled: false,
      currentStep: 0,
      guaranteeModel: {
        cityId: null,
        cities: null,
        guarantorCity: null,
        industryId: null,
        guarantorIndustry: null
      }
    }
  },
  watch: {
  },
  mounted () {
    let pathSegs = this.$route.path.split('/')
    let step = pathSegs[pathSegs.length - 1]
    if (step.toLowerCase().indexOf('step') === 0) {
      this.currentStep = parseInt(step.substr(4)) - 1
    }
    if (this.$route.params.orderNumber) {
      this.getGuaranteeDetail()
    }
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    async checkCityEnableProjectRegister (cityId, industryId) {
      let res = await this.$Api.KVS.getKVS('PROJECT_REGISTER_ENABLED_CITIES').catch(() => {
        return Promise.resolve(false)
      })
      if (!res) {
        return Promise.resolve(false)
      } else {
        // console.log(res)
        let cities = res.split(',')
        // console.log(cities, cityId.toString(), cities.indexOf(cityId.toString()) < 0)
        if (cities.indexOf(cityId.toString()) < 0) {
          return Promise.resolve(false)
        }
        // console.log('city true')
      }
      res = await this.$Api.KVS.getKVS('PROJECT_REGISTER_ENABLED_INDUSTRIES').catch(() => {
        return Promise.resolve(false)
      })
      if (!res) {
        return Promise.resolve(false)
      } else {
        let industries = res.split(',')
        if (industries.indexOf(industryId.toString()) < 0) {
          return Promise.resolve(false)
        } else {
          // console.log('industry true')
          return Promise.resolve(true)
        }
      }
    },
    getGuaranteeDetail () {
      this.$Api.Guarantee.getGuaranteeDetail(this.$route.params.orderNumber)
      .then(async (res) => {
        Object.assign(this.guaranteeModel, res)
        this.guaranteeModel.project.cost /= 100
        this.guaranteeModel.amountCostRatio /= 100
        this.guaranteeModel.amount /= 100
        if (this.guaranteeModel.fee) {
          this.guaranteeModel.fee /= 100
        } else {
          this.guaranteeModel.fee  = null
        }
        this.guaranteeModel.counterTotal /= 100
        this.guaranteeModel.counterCash /= 100
        this.guaranteeModel.counter3rdparty /= 100
        this.guaranteeModel.counterMortgage /= 100
        this.guaranteeModel.counterOther /= 100
        if (this.guaranteeModel.jointGuarantors && this.guaranteeModel.jointGuarantors instanceof Array) {
          this.guaranteeModel.jointGuarantors.forEach((j) => {
            j.amount /= 100
          })
        }
        if (this.guaranteeModel.attachments && this.guaranteeModel.attachments instanceof Array && this.guaranteeModel.attachments.length) {
          this.guaranteeModel.attachments.forEach((att) => {
            if (!att.urls) {
              att.urls = []
            }
          })
        }
        this.projectRegisterEnabled = await this.checkCityEnableProjectRegister(this.guaranteeModel.cityId, this.guaranteeModel.industryId)
        console.log(this.projectRegisterEnabled)
        this.currentStep = 3
        this.$router.replace({path: '/guarantees/new/step4'})
      }).catch(err => {
        this.$Message.error('获取详情失败!' + err.message)
      })
    },
    goBackward () {
      this.currentStep -= 1
      if (this.currentStep === 3) {
        this.guaranteeModel.amount /= 100
        this.guaranteeModel.fee /= 100
        if (this.guaranteeModel.jointGuarantors && this.guaranteeModel.jointGuarantors instanceof Array) {
          this.guaranteeModel.jointGuarantors.forEach((j) => {
            j.amount /= 100
          })
        }
      }
      this.$router.push({path: '/guarantees/new/step' + (this.currentStep + 1)})
    },
    finishStep1 (model) {
      console.log(model)
      this.guaranteeModel.cityId = model.cityId
      this.guaranteeModel.cities = model.cities
      this.guaranteeModel.cityName = model.guarantorCity[0].cityName
      this.guaranteeModel.guarantorCity = model.guarantorCity
      this.currentStep = 1
      this.$router.replace({path: '/guarantees/new/step2'})
    },
    async finishStep2 (guarantorIndustry) {
      console.log(guarantorIndustry)
      this.guaranteeModel.industryId = guarantorIndustry.industryId
      this.guaranteeModel.industryName = guarantorIndustry.industryName
      this.guaranteeModel.guarantorIndustry = guarantorIndustry
      this.projectRegisterEnabled = await this.checkCityEnableProjectRegister(this.guaranteeModel.cityId, this.guaranteeModel.industryId)
      // console.log(this.projectRegisterEnabled)
      this.currentStep = 2
      this.$router.replace({path: '/guarantees/new/step3'})
    },
    finishStep3 (model) {
      console.log(model)
      model.project.cost /= 100
      Object.assign(this.guaranteeModel, model)
      this.currentStep = 3
      this.$router.replace({path: '/guarantees/new/step4'})
    },
    finishStep4 (model) {
      console.log(model)
      Object.assign(this.guaranteeModel, model)
      this.guaranteeModel.contractOssKeys = []
      this.guaranteeModel.contractOssKeys = model.contractOssKeys
      this.currentStep = 4
      this.$router.replace({path: '/guarantees/new/step5'})
    }
  }
}
</script>

<style lang="less" scoped>
.guarantor-new.wrapper {
  display: flex;
  flex-direction: row;
  position: relative;
  overflow: hidden;
  align-items: stretch;
  height: 100%;
  .steps{
    width: 180px;
  }
  .views {
    flex: 1;
    overflow: hidden;
  }
}
</style>
